import React, { useEffect, useRef, useState } from 'react'
import { Container, Alert, Form, Button, Card } from 'react-bootstrap'
import { useAuth } from '../contexts/AuthContext'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Footer from '../components/Footer';
import { motion } from 'framer-motion';
import SideMenu from '../components/SideMenu';

export default function SignUp() {

  const navigate = useNavigate();
  const emailRef = useRef();
  const passwordRef = useRef();
  const confirmPasswordRef = useRef();
  const {signup, currentUser, login } = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false)
  const { path } = useParams();

  useEffect(() => {
    console.log(currentUser);
    if(currentUser && path)
      navigate('/' + path);
    else if(currentUser)
      navigate('/');
  }, [currentUser])

  async function handleGoogleSignIn(){
    try{
      setError('');
      setLoading(true);
      await login(emailRef.current.value, passwordRef.current.value, 'google');
    } catch (e) {
      setError(e.message);
    }

    setLoading(false);
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if(passwordRef.current.value !== confirmPasswordRef.current.value){
      return setError('Invalid Password Confirmation');
    }

    try{
      setError('');
      setLoading(true);
      await signup(emailRef.current.value, passwordRef.current.value);
    } catch (e) {
      setError(e.message);
    }

    setLoading(false);
  }

  return (
    <motion.div 
          initial={{ y: -150, opacity: 0}}
          animate={{ y:0, opacity: 1}}
          exit={{ opacity: 0 }}>
            <SideMenu  pageWrapId={'outer-page-wrapper'} outerContainerId={'inner-page-wrapper'} />
            <Container className='d-flex align-items-center justify-content-center' style={{ minHeight: "100vh" }}>
      
              <div className='w-100 mr-5' style={{ maxWidth: "400px", float: 'left' }}>
        
                  <Link className="mb-4" to="/">Back to Home</Link>
                  <Card className='bg-dark border border-light'>
                      <Card.Body>
                          <h2 className='text-center mb-4'>Sign Up</h2>
                          {currentUser && currentUser.email}
                          {error && <Alert variant="danger">{error}</Alert>}

                          <Button onClick={handleGoogleSignIn} className='bg-transparent mb-2'>
                            <img alt="Sign up with Google" loading="lazy" decoding="async" width={191} height={46} src={window.location.protocol + "//" + window.location.host + '/google-sign-in/google_signin_buttons/web/1x/btn_google_signin_dark_normal_web.png'}></img> 
                          </Button>
                          
                          <Form onSubmit={handleSubmit}>
                              <Form.Group id="email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" ref={ emailRef } required />
                              </Form.Group>

                              <Form.Group id="password">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control type="password" ref={ passwordRef } required />
                              </Form.Group>

                              <Form.Group id="confirm-password">
                                    <Form.Label>Confirm Password</Form.Label>
                                    <Form.Control type="password" ref={ confirmPasswordRef } required />
                              </Form.Group>
                              <Button disabled={loading} className='w-100 mt-2' type="submit">Sign Up</Button>
                          </Form>
                      </Card.Body>
                  </Card>
                  {!path && <div>Do you already have an account? <Link to="/login">Log In</Link></div>}
                  {path && <div>Do you already have an account? <Link to={"/login/" + path}>Log In</Link></div>}
              </div>
            </Container>
            <Footer></Footer>
      </motion.div>
  )
}
